/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { apiFetch } from '../../../apiClient';
import { apiMap } from '../../../config/constants';
import paths from '../../../config/path';
import history from '../../../utils/history';
import BasePage from '../../../shared/BasePage';
import { updateStep } from '../../CompanyRegistration/state/action';
import './style.css';

/* eslint-disable array-callback-return */
class ConfirmPQ extends BasePage {
    constructor(props) {
        super(props);
        this.state = {
            showId: 0
        }
    }
    componentDidMount() {
        this.switchI18n();
    }
    componentWillReceiveProps = (nextProps) => {
        if (nextProps.selectedLanguage !== this.props.selectedLanguage) {
            this.switchI18n();
        }
    }
    switchI18n = () => {
        apiFetch(apiMap.confirmPQi18n)().then((i18n) => {
            i18n && this.setState({ i18n });
        }).catch(error => {});
    }
    onClickAction = () => {
        history.push(paths.logon.path);
    }
    render() {
        const { i18n } = this.state;
        return i18n && this.props.applicationInfo ? (
            <div className="dynamic-form ao-form container pq-form">
                <div className="PQ-top">
                    {/*<i className="icon icon-circle-error"></i>*/}
                    <h1 className="title" data-key="title">{i18n.title}</h1>
                    <p className="sub-tip" data-key="tip">{i18n.reject.tip}</p>
                    {/*<p className="sub-title" data-key="subTitle">{i18n.reject.subTitle}</p>*/}
                    {/*<p className="sub-tip" data-key="subTip">{i18n.reject.subTip}<a href="mailto:rbb.ccss.referral@hsbc.com.cn" title={i18n.reject.email}>{i18n.reject.email}</a></p>*/}
                </div>
                {/*<div className="button"><Button bsStyle="primary" className="btn-back" onClick={this.onClickAction}>{i18n.reject.button}</Button></div>*/}
            </div>
        ) : null
    }
}

ConfirmPQ.propTypes = {
    showId: PropTypes.number
};

const mapStateToProps = (state) => ({
    showId: state.previewQuestion.showId,
    selectedLanguage: state.app.selectedLanguage,
    applicationInfo: state.app.applicationInfo
});

export default connect(mapStateToProps, {
    updateStep
})(ConfirmPQ)


// WEBPACK FOOTER //
// ./src/views/ConfirmPQ/container/ConfirmPQ.js